let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2k6cw")).then(() => parcelRequire('gP4kF'));